import config from "@/config";
import { type LogConfig, LogLevel} from "@/models";


class Log {

  config:LogConfig
  constructor(config : LogConfig) {
    this.config = config
  }

  public get logLevel():LogLevel {
    return this.config.logLevel
  }

  d(...args:any[]) { // debug
    if(!this.config.logEnabled || this.logLevel < LogLevel.Debug) return;
    console.debug('[DEBUG]', ...args);
  }
  i(...args:any[]) { // info
    if(!this.config.logEnabled || this.logLevel < LogLevel.Info) return;
    console.log('[INFO]', ...args);
  }
  w(...args:any[]) { // warning
    if(!this.config.logEnabled || this.logLevel < LogLevel.Warning) return;
    console.warn('[WARNING]', ...args);
  }
  e(...args:any[]) { // error
    if(!this.config.logEnabled || this.logLevel < LogLevel.Error) return;
    console.error('[ERROR]', ...args);
  }

}

const log = new Log(config)
export default log
